export default function(data) {
  return {
    exception: data.exception,
    payload: data.payload,
  }
}
